import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: {
    items: [],
    page: 1,
    size: 50,
    total: 0,
    status: "idle",
    error: null,
  },
  create: {
    status: "idle",
    error: null,
    audit: null,
  },
  report: {
    status: "idle",
    error: null,
    job: null,
    downloadUrl: null,
    auditId: null,
  },
};

const auditHubSlice = createSlice({
  name: "auditHub",
  initialState,
  reducers: {
    fetchAudits: (state) => {
      state.list.status = "loading";
      state.list.error = null;
    },
    fetchAuditsSuccess: (state, { payload }) => {
      state.list.status = "succeeded";
      state.list.items = payload.items || [];
      state.list.page = payload.page ?? 1;
      state.list.size = payload.size ?? 50;
      state.list.total = payload.total ?? 0;
      state.list.error = null;
    },
    fetchAuditsFailure: (state, { payload }) => {
      state.list.status = "failed";
      state.list.error = payload?.message || "Unable to load audits.";
    },
    createAudit: (state) => {
      state.create.status = "loading";
      state.create.error = null;
      state.create.audit = null;
    },
    createAuditSuccess: (state, { payload }) => {
      state.create.status = "succeeded";
      state.create.audit = payload;
      state.create.error = null;
    },
    createAuditFailure: (state, { payload }) => {
      state.create.status = "failed";
      state.create.error = payload?.message || "Unable to create the audit.";
    },
    resetCreateAudit: (state) => {
      state.create = { status: "idle", error: null, audit: null };
    },
    requestAuditReport: (state, { payload }) => {
      state.report.status = "loading";
      state.report.error = null;
      state.report.job = null;
      state.report.downloadUrl = null;
      state.report.auditId = payload?.auditId || null;
    },
    requestAuditReportSuccess: (state, { payload }) => {
      state.report.status = "succeeded";
      state.report.job = payload;
      state.report.downloadUrl = payload?.downloadUrl || null;
      state.report.error = null;
    },
    requestAuditReportFailure: (state, { payload }) => {
      state.report.status = "failed";
      state.report.error = payload?.message || "Unable to generate the report.";
    },
    resetAuditReport: (state) => {
      state.report = {
        status: "idle",
        error: null,
        job: null,
        downloadUrl: null,
        auditId: null,
      };
    },
  },
});

export const {
  fetchAudits,
  fetchAuditsSuccess,
  fetchAuditsFailure,
  createAudit,
  createAuditSuccess,
  createAuditFailure,
  resetCreateAudit,
  requestAuditReport,
  requestAuditReportSuccess,
  requestAuditReportFailure,
  resetAuditReport,
} = auditHubSlice.actions;

export default auditHubSlice.reducer;
